/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HeartsDropdownContainer_app$ref: FragmentReference;
declare export opaque type HeartsDropdownContainer_app$fragmentType: HeartsDropdownContainer_app$ref;
export type HeartsDropdownContainer_app = {|
  +referralVcReward: ?number,
  +$refType: HeartsDropdownContainer_app$ref,
|};
export type HeartsDropdownContainer_app$data = HeartsDropdownContainer_app;
export type HeartsDropdownContainer_app$key = {
  +$data?: HeartsDropdownContainer_app$data,
  +$fragmentRefs: HeartsDropdownContainer_app$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "HeartsDropdownContainer_app",
  "type": "App",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "referralVcReward",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '47d4f1227f7115d8412229103f6ab617';
module.exports = node;
